<template>
  <div class="settings" v-resize="utility_onResize">
    <v-layout wrap>
      <v-flex xs12 pt-0>
        <StoreHeader
          :heading="`${orderHistoryTitleCheck} ${headerTitleCheck}`"
          minimal
        ></StoreHeader>
      </v-flex>
    </v-layout>

    <v-container grid-list-lg>
      <v-row class="layout">
        <v-col cols="12" sm="4" md="4" lg="3" class="pb-0 pt-2" :order="isMobile ? '2' : '1'">
          <div class="nav-container">
            <v-card flat class="nav light-border">
              <SettingsNav :user="getMe" :loading="isLoadingUser"></SettingsNav>
            </v-card>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="8"
          lg="9"
          class="settings-content pl-6"
          :order="isMobile ? '1' : '2'"
        >
          <main>
            <transition name="slideDown" :duration="300" mode="out-in">
              <component :is="routeKey" :limitedUser="limitedUser"></component>
            </transition>
          </main>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import meMixin from '@/mixins/meMixin';
import utilityMixin from '@/mixins/utilityMixin';
import EditProfileForm from '@/components/settings/EditProfileForm';
import AccountSettings from '@/components/settings/AccountSettings';
import LicenseSettings from '@/components/settings/LicenseSettings';
import OrderHistory from '@/components/settings/OrderHistory';
import PreferenceSettings from '@/components/settings/PreferenceSettings';
import SettingsNav from '@/components/SettingsNav';

//* Code-splitting component imports
const StoreHeader = () => {
  return import(/* webpackPrefetch: true */ '@/components/StoreHeader');
};

export default {
  name: 'settings',
  mixins: [meMixin, utilityMixin],
  props: ['subTitle', 'subTitleKey', 'routeKey'],

  components: {
    profile: EditProfileForm,
    account: AccountSettings,
    licenses: LicenseSettings,
    history: OrderHistory,
    preferences: PreferenceSettings,
    SettingsNav,
    StoreHeader,
  },

  data() {
    return {};
  },

  mounted() {
    // console.log(this.$route);
  },

  computed: {
    ...mapGetters({
      limitedUser: 'users/limitedUser',
    }),

    orderHistoryTitleCheck() {
      // return this.$route.meta.header === 'History' ? '' : 'Manage';
      return this.$route.meta.header === 'History' ? '' : this.$t('store.manage');
    },

    headerTitleCheck() {
      return this.$route.meta.title
        ? this.$t(`store.${this.$route.meta.title.toLowerCase()}`)
        : this.$t('store.account');
    },
  },
};
</script>

<style scoped>
.nav {
  min-height: 105vh;
  border-radius: 0;
  background-color: var(--darkWhite, #f5f5f5);
}

.theme--dark .nav {
  background-color: var(--grey-themeDark, #424242);
}

.nav-container {
  min-width: 240px;
}

.settings-content {
  margin-top: 0;
}

.custom-flex {
  display: flex;
}

.flex-center {
  display: flex;
  justify-content: center;
}

main {
  width: 100%;
}

@media (max-width: 600px) {
  .settings-content {
    padding-left: 8px !important;
    margin-top: -60px;
  }

  .nav-container {
    margin-top: 75px;
  }

  .nav {
    padding-bottom: 0;
    border-top-left-radius: var(--border-5, 5px);
    border-top-right-radius: var(--border-5, 5px);
  }
}
</style>
